import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from '../../../environments/environment';
import { AppConfig, Facet, FacetValue, FacetSearchCriteria } from "../webapi/faceted-search-app.model";
import { FacetedSearchAppService } from "../webapi/faceted-search-app.service";
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'facet',
  templateUrl: './facet.component.html',
  styleUrls: ['./facet.component.css']
})


export class FacetComponent implements OnInit {

  constructor(private facetedSearchAppService: FacetedSearchAppService) {
  }

  @Input()
  facet: Facet;

  @Output()
  onChange = new EventEmitter<any>();

  @Output()
  displayAll: boolean = false;

  @Output()
  get activeClass(): string {
    let facetCriteria = this.facetedSearchAppService.currentSearchCriteria.keyValue(this.facet.id);
    return ((!facetCriteria || facetCriteria.count == 0) ? "nothing-selected" : "something-selected")
  }

  readonly facetTypeCheckboxes: number = 1;
  readonly facetTypeRadio: number = 2;
  readonly facetTypeDropdown: number = 3;

  public get facetValues(): FacetValue[] {
    return (this.facetValueList == null ? null : (this.displayAll ? this.facetValueList : this.facetValueList.slice(0, 10)));
  }

  facetValueList: FacetValue[];
  
  toggleDisplayAll(e: any) {
    this.displayAll = !this.displayAll;
  }

  isSelected(facetValueId: number): boolean {
    let facetCriteria = this.facetedSearchAppService.currentSearchCriteria.keyValue(this.facet.id);
    return (facetCriteria && facetCriteria.contains(facetValueId));
  }

  onFacetCheckboxValueChanged(e: MatCheckboxChange) {
    let facetValueId: number = Number(e.source.value);
    let checked: boolean = e.checked;
    let facetCriteria = this.facetedSearchAppService.currentSearchCriteria.keyValue(this.facet.id);
    if (!facetCriteria) {
      facetCriteria = this.facetedSearchAppService.currentSearchCriteria.add(this.facet.id, new FacetSearchCriteria(this.facet));
    }
    if (checked) {
      facetCriteria.add(facetValueId);
    }
    else {
      facetCriteria.remove(facetValueId);
    }
    this.onChange.emit('');
  }

    onFacetDropdownValueChanged(e: MatSelectChange) {
    let facetCriteria = this.facetedSearchAppService.currentSearchCriteria.keyValue(this.facet.id);
    if (!facetCriteria) {
      facetCriteria = this.facetedSearchAppService.currentSearchCriteria.add(this.facet.id, new FacetSearchCriteria(this.facet));
    }
    facetCriteria.clear();
    if (!e.source.empty && e.value != "") {
      facetCriteria.add(e.value);
    }
    this.onChange.emit('');
  }

  ngOnInit(): void {
    this.facetedSearchAppService.facetValues(this.facet.id).then(x => {
      this.facetValueList = x;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/fsapplication/facet/facet.component.ts